import React from 'react';
import { Marker, Popup } from 'react-leaflet';
import { careIcon } from './buildingIcons';

// Centres CARE enregistres, avec leur icone dediee
const CareMarkers = ({ centers = [], prefix = 'care' }) => (
    <>
        {centers.filter((c) => c.latitude && c.longitude).map((c) => (
            <Marker key={`${prefix}-${c.id}`} position={[c.latitude, c.longitude]} icon={careIcon}>
                <Popup>
                    <div className="text-xs">
                        <b>Centre CARE — {c.name}</b><br />
                        {c.address}<br />
                        {c.current_count || 0}/{c.capacity} personnes
                    </div>
                </Popup>
            </Marker>
        ))}
    </>
);

export default CareMarkers;
